export default "__VITE_ASSET__t5a_2vLE__"